import { css } from '@emotion/react';

const chargeStyles = {
    collapseBlock: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        backgroundColor: '#ffffff',
        position: 'absolute',
        top: '0',
        left: '0',
        padding: '16px',
        zIndex: 10002,
    }),
    battery: css({
        borderRadius: '8px',
        backgroundColor: '#101010',
        height: '6rem',
        width: '100%',
        maxWidth: 'calc(100vw - 20%)',
        margin: '1rem 3rem 1rem 2rem',
        position: 'relative',
        padding: '0.5rem',
        display: 'flex',
        justifyContent: 'flex-end',
        ':after': {
            content: '""',
            width: '10px',
            height: '30px',
            position: 'absolute',
            right: '-15px',
            top: 'calc(50% - 15px)',
            background: '#FFF300',
            borderRadius: '4px 8px 8px 4px',
        },
    }),
    batteryEmpty: css({
        height: '100%',
        background: '#ffffff',
        borderRadius: '8px',
        opacity: 0.9,
    }),
    batteryPercent: css({
        position: 'absolute',
        top: 'calc(50% - 2rem)',
        left: 0,
        width: '100%',
        textAlign: 'center',
        fontSize: '3.125rem',
        fontWeight: 800,
        color: 'white',
        mixBlendMode: 'difference',
        ':after': {
            content: '"%"',
            fontSize: '1.5rem',
        },
    }),
    modalContainer: css({
        margin: '0 auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '30px',
        outline: 'none',
        overflowY: 'auto',

        '@media (min-width: 600px)': {
            justifyContent: 'center',
            maxWidth: '375px',
        },
    }),
    modalContentBlock: css({
        padding: '16px',
        backgroundColor: '#ffffff',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        '@media (min-width: 600px)': {
            borderRadius: '8px',
            maxWidth: '375px',
            height: 'unset',
        },
    }),
    stationInfo: css({
        color: '#000000',
        fontSize: '15px',
        fontWeight: '700',
    }),
    modalContentBlockFooter: css({
        '@media (min-width: 600px)': {
            display: 'none',
        },
    }),
    loaderContainer: css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px 0'
    }),
};

export default chargeStyles;
